<template>
  <a-modal
    title="配送任务详情"
    :width="720"
    :visible="visible"
    :footer="null"
    @cancel="visible = false"
    style="top:60px;">
    <a-spin :spinning="loading">
      <div class="task-info">
        <div class="info-row">
          <span class="label">任务号</span><span>{{ task.taskNo }}</span>
          <span class="label" style="margin-left: 24px">配送员</span><span>{{ task.courierName }}</span>
        </div>
        <div class="info-row">
          <span class="label">状态</span><span>{{ task.statusName }}</span>
          <span class="label" style="margin-left: 24px">进度</span><span>{{ task.signedCount }}/{{ task.stopCount }}</span>
        </div>
        <div class="info-row">
          <span class="label">路线方案</span><span>{{ task.routeModeName }}</span>
        </div>
        <div v-if="task.routeSummary" class="info-row">
          <span class="label">方案摘要</span><span>{{ task.routeSummary }}</span>
        </div>
        <div class="info-row share-row">
          <span class="label">配送员链接</span>
          <a-input :value="h5Link" readonly class="share-input">
            <a-icon slot="suffix" type="copy" class="copy-icon" @click="copyLink" />
          </a-input>
          <a-button size="small" type="primary" @click="copyLink">复制</a-button>
        </div>
        <div class="share-tip">将链接发给配送员，手机浏览器打开即可查看任务并逐点签收（免登录）</div>
      </div>
      <a-table
        size="small"
        bordered
        rowKey="id"
        :columns="stopColumns"
        :dataSource="task.stops || []"
        :pagination="false">
        <template slot="status" slot-scope="text, record">
          <a-tag :color="record.status === '1' ? 'green' : 'orange'">{{ record.statusName }}</a-tag>
        </template>
      </a-table>
    </a-spin>
  </a-modal>
</template>
<script>
import { getDeliveryTask } from '@/api/plugin/orderReceive'

export default {
  name: 'DeliveryTaskDetailModal',
  data() {
    return {
      visible: false,
      loading: false,
      task: {},
      stopColumns: [
        {
          title: '顺序',
          dataIndex: 'seq',
          width: 60,
          align: 'center'
        },
        {
          title: '客户',
          dataIndex: 'customerName',
          width: 160,
          customRender: function(text) {
            return text || '-'
          }
        },
        {
          title: '出库单号',
          dataIndex: 'xsckNo',
          width: 140
        },
        {
          title: '配送地址',
          dataIndex: 'address',
          width: 220,
          customRender: function(text) {
            return text || '-'
          }
        },
        {
          title: '签收状态',
          dataIndex: 'status',
          width: 90,
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '签收时间',
          dataIndex: 'signedTime',
          width: 150,
          customRender: function(text) {
            return text || '-'
          }
        }
      ]
    }
  },
  computed: {
    h5Link() {
      if (!this.task.secureToken) {
        return ''
      }
      return window.location.origin + window.location.pathname + '#/h5/delivery/' + this.task.secureToken
    }
  },
  methods: {
    open(taskId) {
      this.visible = true
      this.loading = true
      this.task = {}
      getDeliveryTask(taskId).then(res => {
        if (res.success) {
          this.task = res.data || {}
        } else {
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    copyLink() {
      if (!this.h5Link) {
        return
      }
      const input = document.createElement('textarea')
      input.value = this.h5Link
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('链接已复制')
    }
  }
}
</script>
<style scoped>
.task-info {
  margin-bottom: 16px;
}
.info-row {
  display: flex;
  align-items: center;
  padding: 4px 0;
  font-size: 14px;
}
.label {
  color: #888;
  margin-right: 8px;
}
.share-row .share-input {
  flex: 1;
  margin-right: 8px;
}
.copy-icon {
  color: #1890ff;
  cursor: pointer;
}
.share-tip {
  color: #999;
  font-size: 12px;
  margin-top: 4px;
  margin-bottom: 8px;
}
</style>
